import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { KeyRound, ShieldCheck } from 'lucide-react';
import { api } from '../lib/api';
import { toast } from 'sonner';

export default function MiAreaActivar() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('t') || '';
  const [pin, setPin] = useState('');
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pin.length !== 6) { toast.error('El código PIN tiene 6 dígitos'); return; }
    if (pw.length < 8) { toast.error('La contraseña debe tener al menos 8 caracteres'); return; }
    if (pw !== pw2) { toast.error('Las contraseñas no coinciden'); return; }
    setBusy(true);
    try {
      await api.portalActivate(token, pin, pw);
      toast.success('Acceso activado. Ya puedes iniciar sesión.');
      navigate('/mi-area');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'No se pudo activar el acceso');
    } finally { setBusy(false); }
  };

  if (!token) {
    return (
      <div className="max-w-md mx-auto px-4 py-20 text-center">
        <p className="text-stone-500">Enlace no válido. Solicita uno nuevo a la autoescuela.</p>
        <Link to="/" className="text-teal-600 text-sm hover:underline block mt-4">← Volver al inicio</Link>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <form onSubmit={submit} className="bg-white rounded-xl shadow-lg border border-stone-200 p-8 text-center" data-testid="portal-activate-form">
        <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <KeyRound className="w-5 h-5 text-amber-600" />
        </div>
        <h1 className="text-xl font-black text-stone-800 mb-1">Activa tu Área de Alumno</h1>
        <p className="text-sm text-stone-500 mb-6">Introduce el código PIN de 6 dígitos que te ha facilitado la autoescuela y crea tu contraseña.</p>
        <input
          value={pin}
          onChange={(e) => setPin(e.target.value.replace(/\D/g, '').slice(0, 6))}
          inputMode="numeric"
          placeholder="Código PIN (6 dígitos)"
          className="w-full border border-stone-300 rounded px-4 py-3 text-center text-xl tracking-[0.5em] font-black focus:outline-none focus:ring-2 focus:ring-amber-400 mb-3"
          data-testid="portal-pin-input"
        />
        <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Crea tu contraseña (mín. 8)" autoComplete="new-password" className="w-full border border-stone-300 rounded px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-amber-400 mb-3" data-testid="portal-password-input" />
        <input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Repite la contraseña" autoComplete="new-password" className="w-full border border-stone-300 rounded px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-amber-400 mb-5" data-testid="portal-password2-input" />
        <button type="submit" disabled={busy} className="btn-natur w-full py-3 rounded font-bold text-sm disabled:opacity-60" data-testid="portal-activate-button">
          {busy ? 'Activando…' : 'Activar y continuar'}
        </button>
        <p className="text-[11px] text-stone-400 mt-4 flex items-center justify-center gap-1.5"><ShieldCheck className="w-3.5 h-3.5" /> Enlace de un solo uso · caduca en 7 días · 5 intentos máximo</p>
      </form>
    </div>
  );
}
